import { Box } from "@mui/material";

export function AllDeviceIcon() {
  return (
    <Box
      component="span"
      className="MuiSvgIcon-root"
      sx={{
        display: "inline-block",
        width: "1em",
        height: "1em",
        backgroundColor: "currentColor",
        mask: "url(/images/icons/mui-custom/device_all.svg) center / contain no-repeat",
        WebkitMask: "url(/images/icons/mui-custom/device_all.svg) center / contain no-repeat",
      }}
    />
  );
}
